import { useMediaQuery } from '@mui/material';

const COMPACT_SCREEN_QUERY = '(max-width: 1250px)';

export function useIsCompactScreen(): boolean {
  return useMediaQuery(COMPACT_SCREEN_QUERY);
}
